export enum HOTEL_STATUS {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
  HIDDEN = 'HIDDEN',
}
